import {isObjectNullOrEmpty} from "../../../../Utilities/Types/objectUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {checkAndSetError, clearInputFormErrorFields, inputFormIsValid} from "../../../../Components/Inputs";
import {APH_QUEUE_STATUS} from "./aphQueueConstants";

export const filterQueueByStatus = (queue: Record<string, any>[], isPending = true) => {
return queue.filter((q: Record<string, any>) =>
        isPending
            ? q.aphQueueStatus === APH_QUEUE_STATUS.Pending
            : q.aphQueueStatus === APH_QUEUE_STATUS.InReview
    );
};


export function getAllDuplicateAphCatalogItemForStudent(studentQueueViewModel: Record<string, any>, pendingQueue: Record<string, any>[], processingQueue: Record<string, any>[]) {

const catalogTitleDuplicates = new Set();

if (isObjectNullOrEmpty(studentQueueViewModel.studentId))
    return [];

const studentQueueItems = pendingQueue.filter((q: Record<string, any>) => studentQueueViewModel.queueItemIds.includes(q.aphQueueItemId))
studentQueueItems.forEach((studentQueueItem: Record<string, any>) => {

    const matchingProcessingQueueItems = processingQueue.filter((q: Record<string, any>) => q.student?.studentId === studentQueueViewModel.studentId && q.aphCatalogItem.title === studentQueueItem.aphCatalogItem.title);
        const hasMatchingProcessingQueueItems = !isArrayNullOrEmpty(matchingProcessingQueueItems);

        if (hasMatchingProcessingQueueItems) {

            const title = studentQueueItem.aphCatalogItem.title;
            const isTitleDuplicate = catalogTitleDuplicates.has(title);
            if (!isTitleDuplicate) {
                catalogTitleDuplicates.add(title);
            }
        }
    });

    return Array.from(catalogTitleDuplicates) as string[];
}

export function createConfirmationMessageForDuplicateAphCatalogItems(duplicateAphCatalogItemForStudent: string[], hasDuplicateAphCatalogItem: boolean) {
let confirmationMessage = "";

if (hasDuplicateAphCatalogItem) {
    confirmationMessage += `You are about to add the following same books to the same student. With the titles listed below.\n`;

    duplicateAphCatalogItemForStudent.forEach((title: string) => {
            confirmationMessage += `\n ${title}\n`;
        });

        confirmationMessage += `\nAre you sure you want to proceed?`;
    }

    return confirmationMessage;
}


export function getTotalCost(aphQueue: Record<string, any>[]) {
if (isArrayNullOrEmpty(aphQueue))
    return 0;

const totalCost = aphQueue.reduce((total: number, item: Record<string, any>) => total + (item.aphCatalogItem.cost || 0), 0);
    return convertToCurrencyFormat(totalCost);
}

export function convertToCurrencyFormat(value: string | number) {
    if (isNaN(Number(value)) || isNullOrUndefined(value)) {
        return "";
    }
    return `$ ${parseFloat(String(value)).toFixed(2)}`;
}

export function isAphLoanFormValid(aphLoanForm: Record<string, any>) {
    clearInputFormErrorFields(aphLoanForm);
    checkAndSetError([
        aphLoanForm.studentId,
        aphLoanForm.shippingLocationId,
    ]);

    return inputFormIsValid(aphLoanForm);
}